import { useContext } from 'react'

import { AppContext } from '../AppProvider'

export function useApp() {
  return useContext(AppContext)
}
